import { useCallback, useState } from 'react';

type SettingsDialogState = [boolean, () => void, () => void];

export const useSettingsDialogState = ({
  onMenuClose
}: {
  onMenuClose: () => void;
}): SettingsDialogState => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const onMenuItemClick = useCallback(() => {
    onMenuClose();
    setDialogOpen(true);
  }, [onMenuClose, setDialogOpen]);

  const onClose = useCallback(() => {
    setDialogOpen(false);
  }, [setDialogOpen]);

  return [dialogOpen, onMenuItemClick, onClose];
};
